/* closest integer to `a` that is divisible by `b` */
export default (a, b) => {
  const c1 = a - (a % b),
    c2 = a + b - (a % b)

  if (a - c1 > c2 - a) {
    return c2
  } else {
    return c1
  }
}
